<template>
  <div style="max-width: 350px">
    <div v-if="mode === 'DESIGN'">
      <el-button disabled icon="el-icon-user" type="primary" size="mini" round>选择人员</el-button>
      <span class="placeholder"> {{ placeholder }}</span>
    </div>
    <div v-else>
      <el-button icon="el-icon-user" type="primary" size="mini" round @click="selectUser">选择人员</el-button>
      <dept-picker
        v-if="showOrgSelect"
        type="user"
        title="请选择人员"
        :multiple="multiple"
        ref="orgPicker"
        :selected="_value"
        @ok="selected"
        @close="showOrgSelect=false"
      />
      <span class="placeholder"> {{ placeholder }}</span>
      <div style="margin-top: 5px">
        <el-tag
          size="mini"
          style="margin: 5px"
          closable
          v-for="(dept, i) in _value"
          :key="i"
          @close="delDept(i)">{{ dept.name }}</el-tag>
      </div>
    </div>
  </div>
</template>

<script>
import componentMinxins from '../ComponentMinxins'
import DeptPicker from '@/components/common/DeptPicker'

export default {
  mixins: [componentMinxins],
  name: 'UserPicker',
  components: { DeptPicker },
  props: {
    value: {
      type: Array,
      default: () => {
        return []
      }
    },
    placeholder: {
      type: String,
      default: '请选择人员'
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showOrgSelect: false
    }
  },
  methods: {
    selected (values) {
      this.showOrgSelect = false
      this._value = values
    },
    delDept (i) {
      this._value.splice(i, 1)
    },
    selectUser () {
      this.orgPickerType = 'user'
      this.showOrgSelect = true
      console.log('选择人员按钮点击')
      // this.$refs.orgPicker.show()
    }
  }
}
</script>

<style scoped>
.placeholder{
  margin-left: 10px;
  color: #adabab;
  font-size: smaller;
}
</style>
